/*
 * Copyright © 2021 Firecrest Clinical, Ltd.
 * All rights reserved.
 */

import { NgModule } from '@angular/core';
import {CommonModule} from '@angular/common';
import { FcTooltipModule } from '../fc-tooltip/fc-tooltip.module';
import {FcAgContextMenuComponent} from './fc-ag-context-menu.component';
import {FcAgContextHolderComponent} from './fc-ag-context-holder.component';

/**
 * Fc Context module with Angular.
 */
@NgModule({
    declarations: [
        FcAgContextHolderComponent,
        FcAgContextMenuComponent
    ],
    imports: [
        CommonModule,
        FcTooltipModule
    ],
    exports: [
        FcAgContextHolderComponent,
        FcAgContextMenuComponent
    ]
})
export class FcAgContextModule {
}
